import React from 'react';

import { renderMoneyAmountShort } from '../../components/formBuilder/utility/renderValue';
import OverviewDivider from '../../components/property-summaries/OverviewDivider';
import ClearBadge from '../../components/property-summaries/ClearBadge';
import { HashLink } from 'react-router-hash-link';

export default function BRRRRSummaryOverview({ propertyData }) {
  const timeToComplete = propertyData.rehabLength;
  const totalCashInvested = propertyData.totalCashInvestedWithDownPayment;
  const netMonthlyIncome = propertyData.netMonthlyIncome;
  const cashFlow = propertyData.newMonthlyPreTaxCashFlow;
  const investmentRecovered = propertyData.investmentRecovered;

  let cashOut = propertyData.cashOut;
  let cashLeftIn = 0;

  const profit = propertyData.cashOut;

  if (profit >= 0) {
    cashLeftIn = 0;
    if (investmentRecovered >= totalCashInvested) {
      cashOut = profit + investmentRecovered;
    } else {
      cashOut = profit;
    }
  } else {
    cashLeftIn = Math.abs(profit);
    cashOut = investmentRecovered;
  }

  return (
    <section className="rounded-lg relative bg-white p-4">
      <div className="flex flex-col sm:flex-row relative sm:flex-nowrap items-stretch gap-2 sm:gap-0">
        <div className="flex-grow bg-[#F5F6F4] rounded-lg sm:rounded-r-none sm:rounded-l-lg py-4 px-3 lg:px-6">
          <div className="relative">
            <div
              className="absolute inset-0 flex items-center"
              aria-hidden="true"
            >
              <div className="w-full border-t border-neutral-200"></div>
            </div>
            <div className="relative flex justify-center">
              <span className="bg-[#F5F6F4] px-5 text-md text-neutral-600">
                Total Investment
              </span>
            </div>
          </div>
          <div className="px-2 mt-7 mb-4">
            <div className="grid grid-cols-2 gap-2">
              <div className="flex flex-col justify-center">
                <h4 className="text-[12px] font-normal text-neutral-600">
                  Time to complete
                </h4>
                <p className="text-xl font-serif text-neutral-900 font-medium">
                  {timeToComplete} months
                </p>
              </div>
              <div className="flex flex-col justify-center">
                <h4 className="font-normal text-neutral-600 text-md">
                  Total Cash Invested
                </h4>
                <p className="text-6xl font-serif text-neutral-900 font-medium printing-text-spacing">
                  {renderMoneyAmountShort(totalCashInvested)}
                </p>
              </div>
            </div>
          </div>
        </div>
        <OverviewDivider />
        <div className="flex-grow bg-[#EFF8F3] rounded-lg sm:rounded-l-none rounded-r-lg py-4 px-3 lg:px-6">
          <div className="relative">
            <div
              className="absolute inset-0 flex items-center"
              aria-hidden="true"
            >
              <div className="w-full border-t border-neutral-200"></div>
            </div>
            <div className="relative flex justify-center">
              <span className="bg-[#EFF8F3] text-md px-5 text-neutral-600">
                Post Refinance
              </span>
            </div>
          </div>
          <div className="px-2 mt-7 mb-4 flex flex-col sm:flex-row flex-wrap">
            <div className="flex justify-between gap-4 sm:flex-1 pr-4 ">
              <div className="flex-1 flex flex-col justify-center">
                <h4 className="text-[12px] font-normal text-neutral-600">
                  Cash Left In
                </h4>
                <p className="text-xl font-serif text-neutral-900 font-medium">
                  {renderMoneyAmountShort(cashLeftIn)}
                </p>
              </div>
              <div className="flex-1 flex flex-col items-start justify-center">
                <h4 className="font-normal text-neutral-600 text-md">
                  Cash Taken Out
                </h4>
                <div className="flex items-center justify-center gap-4 printing-text-spacing">
                  <p className="text-6xl font-serif text-neutral-900 font-medium">
                    {renderMoneyAmountShort(cashOut)}
                  </p>
                  {profit >= 0 && (
                    <ClearBadge amount={profit}>
                      {renderMoneyAmountShort(profit, true)}
                    </ClearBadge>
                  )}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-2 sm:flex-1 relative sm:pl-6 ">
              <div className="hidden sm:block absolute h-[18px] w-[1px] bg-neutral-200 left-0 top-[50%] translate-y-[-50%]"></div>
              <div className="flex flex-col justify-center">
                <h4 className="text-[12px] font-normal text-neutral-600">
                  Net Income
                </h4>
                <p className="text-xl font-serif text-neutral-900 font-medium">
                  {renderMoneyAmountShort(netMonthlyIncome)}/mo
                </p>
              </div>
              <div className="flex flex-col justify-center">
                <HashLink
                  smooth
                  to="#cash-flow"
                  scroll={(el) => {
                    el.scrollIntoView({
                      behavior: 'smooth',
                      block: 'center',
                    });
                  }}
                >
                  <h4 className="font-normal text-neutral-600 text-md hover:underline">
                    Cashflow
                  </h4>
                </HashLink>
                <HashLink
                  smooth
                  to="#cash-flow"
                  scroll={(el) => {
                    el.scrollIntoView({
                      behavior: 'smooth',
                      block: 'center',
                    });
                  }}
                >
                  <p className="text-6xl font-serif text-neutral-900 font-medium printing-text-spacing hover:underline underline-offset-4">
                    {renderMoneyAmountShort(cashFlow)}/mo
                  </p>
                </HashLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
